<template>
    <div id="settings_history_modal"
         class="modal fade"
         role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document" style="max-width: fit-content; width: 90%">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title pb-2" id="myExtraLargeModalLabel">{{ $t('Settings History') }}</h2>
                    <button type="button" class="btn-close pb-2" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body table-responsive">
                    <table class="table table-hover table-bordered table-w-auto text-nowrap text-center">
                        <thead>
                        <tr>
                            <th><b>{{ $t('Collected') }}</b></th>
                            <th><b>{{ $t('Source/Status') }}</b></th>
                            <th v-for="label in labels"><b>{{ label }}</b></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(setting, idx) in reversedData" :class="rowColor(setting)">
                            <th><b>{{ dateAndTime(setting.collected) }}</b></th>
                            <td class="capitalized">{{ rowSource(setting) }}</td>
                            <td v-for="(ignored, name) in labels" :class="[rowColor(setting), {'changed': Object.hasOwn(setting.diffFromPrevious, name)}]">
                                <template v-if="Object.hasOwn(setting.therapy, name)">
                                    {{ setting.therapy[name].value }}
                                </template>
                                <template v-else-if="setting.comfort && Object.hasOwn(setting.comfort, name)">
                                    {{ setting.comfort[name].value }}
                                </template>
                                <template v-else-if="setting.alerts && Object.hasOwn(setting.alerts, name)">
                                    {{ setting.alerts[name].value }}
                                </template>
                                <template v-else>&nbsp;</template>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {computed, onMounted, ref, watch} from "vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import {dateAndTime} from "@/utilities/date";

const props = defineProps({
    patient_id: {
        type: Number,
        required: true,
    },
    history_id: {
        type: Number,
        required: true,
    },
})

const data = ref([]);
const labels = ref(null);
onMounted(loadHistory);
watch(() => props.history_id, loadHistory);

function loadHistory() {
    axios.get('/api/patients/' + props.patient_id + '/devices/' + props.history_id + '/settings_history')
        .then((res) => {
            data.value = res.data.data;
            labels.value = res.data.labels;
        })
}
const reversedData = computed(() => {
    return [...data.value].reverse();
});
function rowSource(settings) {
    if( settings.submitted_by ) {
        switch( settings.status ) {
        case 'Failed Delivery':
            return settings.submitted_by + ' (Failed)';
        case 'Pending Delivery':
            return settings.submitted_by + ' (Pending)';
        case 'Void/Replaced':
            return settings.submitted_by + ' (Replaced)';
        default:
            return settings.submitted_by;
        }
    }

    return settings.status;
}
function rowColor(settings) {
    if (!settings.status) {
        return '';
    }

    if (settings.status.match(/Failed|Void/)) {
        return 'table-danger';
    } else if (settings.status.match(/Pending/)) {
        return 'table-warning';
    }

    return '';
}
</script>

<style scoped>
tr .changed {
    font-weight: bold;
    background-color: lightskyblue !important;
}

.dark-orange {
    background-color: darkorange;
    color: black;
}
</style>
